export const DocumentStatusSelectables = {
  modelKey: 'key',
  selectables:[
    {
      key: 'UNREADABLE_WITHOUT_IBAN',
      value: 'inbox.fax.status.unreadableWithoutIban'
    },
    {
      key: 'INCOMPLETE_WITH_IBAN',
      value: 'inbox.fax.status.incompleteWithIban'
    },
    {
      key: 'INCOMPLETE_WITHOUT_IBAN',
      value: 'inbox.fax.status.incompleteWithoutIban'
    },
    {
      key: 'OTHER',
      value: 'inbox.fax.status.other'
    }
  ]};

export const DocumentTypeSelectables = {
  modelKey: 'key',
  selectables:[
    {
      key: 'WARRANT',
      value: 'inbox.fax.type.warrant'
    },
    {
      key: 'REJECTED_WARRANT',
      value: 'inbox.fax.type.rejectedWarrant'
    },
    // {
    //   key: 'SUPPLEMENT',
    //   value: 'inbox.fax.type.supplement'
    // },
    {
      key: 'BALANCE_LIST',
      value: 'inbox.fax.type.balanceList'
    },
    {
      key: 'REJECTED_BALANCE_LIST',
      value: 'inbox.fax.type.rejectedBalanceList'
    },
    {
      key: 'ADMONITION_BALANCE_LIST',
      value: 'inbox.fax.type.admonitionBalanceList'
    },
    {
      key: 'MISC',
      value: 'inbox.fax.type.misc'
    }
  ]};

export const ReducedDocumentTypeSelectables = {
  modelKey: 'key',
  selectables:[
    {
      key: 'WARRANT',
      value: 'inbox.fax.type.warrant'
    },
    {
      key: 'BALANCE_LIST',
      value: 'inbox.fax.type.balanceList'
    },
    {
      key: 'MISC',
      value: 'inbox.fax.type.misc'
    }
  ]};
